import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  textAlign: 'center',
  fontSize: '28px',
  color: '#383838',
};

export const sxTypographySubTitle: SxProps = {
  fontFamily: 'Unimed-Sans',
  textAlign: 'center',
  color: '#4C4C4C',
};

export const sxButton: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  minHeight: '52px',
  border: '2px solid #00995D',
  color: 'rgb(0,0,0,0.08)',
  '@media (max-width: 899px)': {
    width: 'stretch',
  },
  '@media (max-height: 500px)': {
    width: 'auto',
  },
  '&:focus': {
    background: '#fff'
  }
};

export const sxButtonContained: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  minHeight: '52px',
  '@media (max-width: 899px)': {
    width: 'stretch',
  },
  '@media (max-height: 500px)': {
    width: 'auto',
  }
};


export const sxTextButton: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: 16
};

export const sxCloseIconButton: SxProps = {
  position: 'absolute',
  right: '16px',
  top: '16px',
  color: '#383838',
  '@media(max-width: 650px)': {
    right: '16px',
    top: '12px'
  }
}